import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-horizontal',
  templateUrl: './horizontal.component.html',
  styleUrls: ['./horizontal.component.scss']
})

/**
 * Horizontal Component
 */
export class HorizontalComponent implements OnInit, OnDestroy {

  isCondensed = false;
  private routerSub!: Subscription;

  constructor(private router: Router) { }

  ngOnInit(): void {
    document.body.setAttribute('data-layout', 'horizontal');
    document.body.removeAttribute('data-sidebar');

    // Cierra el menú móvil cuando el usuario navega a otra página
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => this.closeMobileMenu());
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Mobile Toggle Menu
   */
  onToggleMobileMenu() {
    const element = document.getElementById('topnav-menu-content');
    const isOpen = element?.classList.toggle('show');
    if (isOpen) {
      document.body.classList.add('topnav-open');
    } else {
      document.body.classList.remove('topnav-open');
    }
  }

  /**
   * Close mobile menu (used by overlay and X button)
   */
  closeMobileMenu() {
    document.getElementById('topnav-menu-content')?.classList.remove('show');
    document.body.classList.remove('topnav-open');
  }

}
